// Components
import Heading from '@/components/atoms/Heading/Heading';
import PreTitle from '@/components/atoms/PreTitle/PreTitle';

// Hooks
import useResponsive from '@/hooks/useResponsive';

// Other
import { type SectionAvantagesType } from '@/services/blocksSchema';

// Style
import styles from './SectionAvantages.module.css';

interface SectionAvantagesProps {
  preTitle: SectionAvantagesType['preTitle'];
  title: SectionAvantagesType['title'];
  image: SectionAvantagesType['image'];
  sections: SectionAvantagesType['sections'];
}

function SectionAvantages({
  preTitle,
  title,
  image,
  sections,
}: SectionAvantagesProps) {
  const { isMobile } = useResponsive();

  return (
    <div className={styles.bg}>
      <div className={styles.container}>
        <div
          className={`
            ${styles.body}
          `}
        >
          {
            !isMobile ? (
              <img
                src={image.url}
                alt={image.alternativeText || ''}
                className={styles.image}
              />
            ) : null
          }
          
          <div className={styles.content}>
            <div className={styles['content-header']}>
              <PreTitle
                preTitle={preTitle}
                color='light'  
              />
              <Heading
                title={title}
                color='light'
                size='h2'
                Tag='h2'
              />
            </div>
            {
              sections ? (
                <div className={styles.sections}>
                  {
                    sections.map((section) => (
                      <div key={section.title} className={styles.section} >
                        <img src={section.icon.url} alt={section.icon.alternativeText || ''} width={38} height={38} />
                        <Heading
                          title={section.title}
                          size='h4'
                          Tag='h4'
                          color='light'
                        />
                        <p className={styles['section-description']}>
                          {section.description}
                        </p>     
                      </div>
                    ))
                  }
                </div>
              ) : null
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionAvantages;
